import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { getFirebaseDb } from '../firebase/config';
import { getFirebaseStorage } from '../firebase/config';
import { COL } from '../firebase/collections';

export async function submitContactForm({ name, email, company, service, message }) {
  const db = getFirebaseDb();
  await addDoc(collection(db, COL.CONTACTS), {
    name,
    email,
    company: company || '',
    service: service || '',
    message,
    createdAt: serverTimestamp(),
  });
}

export async function submitJobApplication({ name, email, phone, cover, jobTitle, jobId, cvFile }) {
  const db = getFirebaseDb();
  let cvUrl = '';
  if (cvFile) {
    const storage = getFirebaseStorage();
    const safeName = cvFile.name.replace(/[^a-zA-Z0-9._-]/g, '_');
    const path = `applications/${Date.now()}_${safeName}`;
    const storageRef = ref(storage, path);
    await uploadBytes(storageRef, cvFile, { contentType: cvFile.type });
    cvUrl = await getDownloadURL(storageRef);
  }
  await addDoc(collection(db, COL.APPLICANTS), {
    name,
    email,
    phone: phone || '',
    job: jobTitle,
    jobId: jobId || '',
    date: new Date().toISOString().split('T')[0],
    status: 'Applied',
    cvUrl,
    notes: cover || '',
    createdAt: serverTimestamp(),
  });
}
